module.exports = __webpack_public_path__ + "media/images/Timbits-Hockey-Animated-GIF-18c43768.gif";